import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import './GoogleSignIn.css';

function GoogleSignIn({ onNavigate }) {
  const { user, isPro, isMax, isVectorAdmin, isVectorAdminPlus, isBeta, isAdmin, tierReady } = useAuth();


  if (user) {
    // Show user info only (sign out is in hamburger menu)
    const initials = user.name
      .split(' ')
      .map((n) => n[0])
      .join('')
      .toUpperCase()
      .slice(0, 2);

    // Tier label priority: Admin > VectorAdmin > Max > Beta > Pro > Basic.
    // VectorAdmin shares permissions with Max but takes precedence for display
    // so Vector-program staff see their own label.
    let tierBadgeClass = 'basic-badge';
    let tierLabel = 'Basic';
    if (!tierReady) {
      tierBadgeClass = 'basic-badge';
      tierLabel = '···';
    } else if (isAdmin) {
      tierBadgeClass = 'admin-badge';
      tierLabel = 'Admin';
    } else if (isVectorAdmin) {
      tierBadgeClass = 'vector-admin-badge';
      tierLabel = isVectorAdminPlus ? 'Brand Admin+' : 'Brand Admin';
    } else if (isMax) {
      tierBadgeClass = 'max-badge';
      tierLabel = 'Max';
    } else if (isBeta) {
      tierBadgeClass = 'beta-badge';
      tierLabel = 'Beta';
    } else if (isPro) {
      tierBadgeClass = 'pro-badge';
      tierLabel = 'Pro';
    }

    return (
      <div
        className="user-info clickable-user-info"
        onClick={() => onNavigate && onNavigate('account')}
        style={{ cursor: 'pointer' }}
      >
        <div className="user-avatar">
          <span className="user-initials">{initials}</span>
        </div>
        <div className="user-details">
          <div className="user-name">{user.name}</div>
          <div className={`user-badge ${tierBadgeClass}`} aria-busy={!tierReady}>
            {tierLabel}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="google-sign-in-wrapper">
      <button className="custom-google-sign-in-btn" onClick={() => onNavigate && onNavigate('login')}>
        <img className="risklo-signin-icon" src="/RiskLo_LogoOnly.png" alt="" aria-hidden="true" />
        <span className="sign-in-text">Sign in</span>
      </button>
    </div>
  );
}

export default GoogleSignIn;

